"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  fillOpacity: ".3",
  d: "M21.18 11.8 24 8.98C20.93 5.9 16.69 4 12 4S3.07 5.9 0 8.98l2.82 2.82C5.17 9.45 8.41 8 12 8s6.83 1.45 9.18 3.8"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M21.18 11.8C18.83 9.45 15.59 8 12 8s-6.83 1.45-9.18 3.8L12 21z"
}, "1")], 'SignalWifiStatusbar3BarTwoTone');